import WhatsAPP from './WhatsAPP'

export default WhatsAPP
